import React, { Component } from 'react';
// import PropTypes from "prop-types";
import {
  NavLink as RRNavLink,
  Link as RRLink,
  withRouter,
} from 'react-router-dom';

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from 'reactstrap';

const Link = ({ children, to }) => {
  return (
    <NavItem>
      <NavLink activeClassName="active" tag={RRNavLink} to={to}>
        {children}
      </NavLink>
    </NavItem>
  );
};

export class Navigation extends Component {
  state = {
    isOpen: false,
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  renderNavItems = () => {
    const { user, history } = this.props;

    if (user) {
      return (
        <Nav className="ml-auto" navbar>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
              {user.name || user.email_addresses[0]}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem>your contacts</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>help</DropdownItem>
              <DropdownItem>settings</DropdownItem>
              <DropdownItem
                onClick={() => {
                  localStorage.removeItem('token');
                  history.push('/');
                }}
              >
                sign out
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      );
    } else {
      return (
        <Nav className="ml-auto" navbar>
          <Link to="/help">help</Link>
          <Link to="/pricing">pricing</Link>
          <Link to="/features">features</Link>
          <Link to="/login">login</Link>
          <RRLink to="/signup" className="btn btn-outline-primary">
            sign up
          </RRLink>
        </Nav>
      );
    }
  };

  render() {
    return (
      <div className="border-bottom box-shadow">
        <Navbar color="light" light expand="md">
          <RRLink to="/" className="navbar-brand">
            Apricot Book
          </RRLink>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            {this.renderNavItems()}
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
Navigation.propTypes = {};

export default withRouter(Navigation);



// WEBPACK FOOTER //
// ./src/Navigation.js